import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMeasure, useWindowSize } from 'react-use';
import ThemeContext from '../../contexts/themeContext';
import Button from '../../components/bootstrap/Button';
import Portal from '../Portal/Portal';
import useDarkMode from '../../hooks/useDarkMode';
import Icon from '../../components/icon/Icon';
import { useDueDate } from '../../contexts/dueDateContext';
import { useNavigate } from 'react-router-dom';
import DueDateStatusLoader from '../../components/extras/DueDateStatusLoader';

export const HeaderLeft = ({ children, className, isTrial, isTrialDate }) => {
	const { dueDateStatus, remainingDays } = useDueDate();
	const navigate = useNavigate();
	const [isTab, setIsTab] = useState(false);
	const [isCompact, setIsCompact] = useState(false);

	const trialDaysLeft = 5;

	useEffect(() => {
		const handleResize = () => {
			setIsTab(window.innerWidth > 782 && window.innerWidth <= 1230);
			setIsCompact(window.innerWidth < 992);
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	let warningMessage = '';
	let warningTitle = '';

	if (dueDateStatus === 'INVALID') {
		const rd = Number(remainingDays ?? 0);
		warningTitle = 'Payment overdue';
		if (rd === 0) {
			warningMessage =
				'Your payment is now overdue. Kindly pay within today to avoid service suspension.';
		} else {
			const unit = rd === 1 ? 'day' : 'days';
			warningMessage = `Your payment is now overdue. Kindly pay within ${rd} ${unit} to avoid service suspension.`;
		}
	} else if (dueDateStatus === 'WARNING') {
		warningTitle = 'Payment due soon';
		warningMessage =
			'Please ensure your payment is made by the due date to avoid any service interruptions.';
	}

	return (
		<div className={classNames('header-left', 'col-md', className)}>
			{/* <div
				style={{ cursor: 'pointer' }}
			     // onClick={() => navigate('/billing')}
			>
				<div
					style={{
						background: 'linear-gradient(90deg, #fff3cd, #ffe8a1)',
						color: '#6b5200',
						padding: '10px 14px',
						borderRadius: '10px',
						border: '1px solid #ffda6a',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: '12px',
						fontSize: '13px',
						marginTop: isCompact ? '20px' : '0px',
						boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
						transition: 'all 0.2s ease',
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
						<Icon icon='info' className='btn-icon' />

						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<strong style={{ fontSize: '14px' }}>
								Free Trial Active
							</strong>
							<span style={{ opacity: 0.85 }}>
									
							</span>
						</div>
					</div>

					<div
						style={{
							background: '#ffc107',
							color: '#000',
							padding: '5px 12px',
							borderRadius: '20px',
							fontWeight: 700,
							fontSize: '12px',
							whiteSpace: 'nowrap',
							boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
						}}
					>
						{trialDaysLeft} days left
					</div>
				</div>
			</div> */}
			{isTrial && (
				<div style={{ cursor: 'pointer' }}>
					<div
						style={{
							backgroundColor: '#fff3cd',
							color: '#856404',
							padding: '5px',
							borderRadius: '5px',
							border: `1px solid  #ffeeba`,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: '8px',
							fontSize: '11px',
							lineHeight: '1.4',
							marginTop: isCompact ? '20px' : '0px',
						}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<Icon icon='info' className='btn-icon' style={{ flexShrink: 0 }} />
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
								}}>
								<strong style={{ fontSize: '13px' }}>Free Trial Active</strong>
								<span>Enjoy premium features during your trial.</span>
							</div>
						</div>
						<div
							style={{
								// background: '#ffc107',
								// color: '#000',
								padding: '5px 12px',
								borderRadius: '20px',
								fontWeight: 700,
								fontSize: '12px',
								whiteSpace: 'nowrap',
								// boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
								marginLeft: 'auto',
							}}>
							{isTrialDate} days left
						</div>
					</div>
				</div>
			)}

			{!isTrial && (dueDateStatus === 'INVALID' || dueDateStatus === 'WARNING') && (
				<div style={{ cursor: 'pointer' }} onClick={() => navigate('/invoices')}>
					<div
						style={{
							backgroundColor: dueDateStatus === 'INVALID' ? '#f8d7da' : '#fff3cd',
							color: dueDateStatus === 'INVALID' ? '#721c24' : '#856404',
							padding: '5px',
							borderRadius: '5px',
							border: `1px solid ${
								dueDateStatus === 'INVALID' ? '#f5c6cb' : '#ffeeba'
							}`,
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							fontSize: '11px',
							lineHeight: '1.4',
							marginTop: isCompact ? '20px' : '0px',
						}}>
						<Icon icon='info' className='btn-icon' style={{ flexShrink: 0 }} />
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
							}}>
							<strong style={{ fontSize: '13px' }}>{warningTitle}</strong>
							<span>{warningMessage}</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

HeaderLeft.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	isTrial: PropTypes.bool,
	isTrialDate: PropTypes.number,
};

HeaderLeft.defaultProps = {
	className: null,
	isTrial: false,
	isTrialDate: 0,
};

export const HeaderRight = ({ children, className }) => {
	const [ref, { height }] = useMeasure();

	const root = document.documentElement;
	root.style.setProperty('--header-right-height', `${height}px`);

	return (
		<div ref={ref} className={classNames('header-right', 'col-md-auto', className)}>
			{children}
		</div>
	);
};
HeaderRight.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
HeaderRight.defaultProps = {
	className: null,
};

const Header = ({ children, hasLeftMobileMenu, hasRightMobileMenu }) => {
	const { themeStatus } = useDarkMode();

	const [isTrial, setIsTrial] = useState(false);
	const [isTrialDate, setIsTrialDate] = useState(0);

	useEffect(() => {}, [isTrial, isTrialDate]);

	const windowsWidth = useWindowSize().width;
	const [refMobileHeader, sizeMobileHeader] = useMeasure();
	const [refHeader, sizeHeader] = useMeasure();

	const MOBILE_BREAKPOINT = Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE || 992);

	const root = document.documentElement;
	root.style.setProperty('--mobile-header-height', `${sizeMobileHeader.height}px`);
	root.style.setProperty('--header-height', `${sizeHeader.height}px`);

	const {
		asideStatus,
		setAsideStatus,
		leftMenuStatus,
		setLeftMenuStatus,
		rightMenuStatus,
		setRightMenuStatus,
	} = useContext(ThemeContext);

	useLayoutEffect(() => {
		if ((asideStatus || leftMenuStatus || rightMenuStatus) && windowsWidth < MOBILE_BREAKPOINT)
			document.body.classList.add('overflow-hidden');
		return () => {
			document.body.classList.remove('overflow-hidden');
		};
	});

	return (
		<>
			<DueDateStatusLoader setIsTrial={setIsTrial} setIsTrialDate={setIsTrialDate} />
			<header ref={refMobileHeader} className='mobile-header'>
				<div className='container-fluid'>
					<div className='row'>
						<div className='col'>
							<Button
								aria-label='Toggle Aside'
								className='mobile-header-toggle'
								size='lg'
								color={asideStatus ? 'primary' : themeStatus}
								isLight={asideStatus}
								icon={asideStatus ? 'FirstPage' : 'LastPage'}
								onClick={() => {
									setAsideStatus(!asideStatus);
									setLeftMenuStatus(false);
									setRightMenuStatus(false);
								}}
							/>
							{/* {hasLeftMobileMenu && (
								<Button
									aria-label='Toggle Left Menu'
									className='mobile-header-toggle'
									size='lg'
									color={leftMenuStatus ? 'primary' : themeStatus}
									isLight={leftMenuStatus}
									icon={leftMenuStatus ? 'MoreVert' : 'MoreHoriz'}
									onClick={() => {
										setAsideStatus(false);
										setLeftMenuStatus(!leftMenuStatus);
										setRightMenuStatus(false);
									}}
								/>
							)} */}
						</div>
						{hasRightMobileMenu && (
							<div className='col-auto'>
								<Button
									aria-label='Toggle Right Menu'
									className='mobile-header-toggle'
									size='lg'
									color={rightMenuStatus ? 'primary' : themeStatus}
									isLight={rightMenuStatus}
									icon={rightMenuStatus ? 'Menu' : 'MenuOpen'}
									onClick={() => {
										setAsideStatus(false);
										setLeftMenuStatus(false);
										setRightMenuStatus(!rightMenuStatus);
									}}
								/>
							</div>
						)}
					</div>
				</div>
			</header>
			<header
				ref={refHeader}
				className={classNames('header', {
					'header-left-open': leftMenuStatus,
					'header-right-open': rightMenuStatus,
				})}>
				<div className='container-fluid'>
					<div className='row d-flex align-items-center'>
						{React.Children.map(children, (child) => {
							if (React.isValidElement(child) && child.type === HeaderLeft) {
								return React.cloneElement(child, { isTrial, isTrialDate });
							}
							return child;
						})}
						{(leftMenuStatus || rightMenuStatus) && (
							<Portal>
								<div
									role='presentation'
									className={classNames('header-overlay', {
										'header-overlay-left-menu': leftMenuStatus,
										'header-overlay-right-menu': rightMenuStatus,
									})}
									onClick={() => {
										setAsideStatus(false);
										setLeftMenuStatus(false);
										setRightMenuStatus(false);
									}}
								/>
							</Portal>
						)}
					</div>
				</div>
			</header>
		</>
	);
};
Header.propTypes = {
	children: PropTypes.node.isRequired,
	hasLeftMobileMenu: PropTypes.bool,
	hasRightMobileMenu: PropTypes.bool,
};
Header.defaultProps = {
	hasLeftMobileMenu: true,
	hasRightMobileMenu: true,
};

export default Header;
